exports.obterDatasInicioEFim = (periodo) => {
    let date = new Date();
    let firstDay = null;
    let lastDay = null;

    if (periodo == 1) { // mês atual
        firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    } else if (periodo == 2) { // 6 meses
        firstDay = getPastDate(date, 6);
        lastDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    } else if (periodo == 3) { // ano atual
        firstDay = new Date(date.getFullYear(), 0, 1);
        lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    } else if (periodo == 4) { // 1 ano
        firstDay = new Date(date.getFullYear() - 1, date.getMonth(), date.getDate());
        lastDay = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }

    return {
        dtIni: formatDate(firstDay),
        dtFim: formatDate(lastDay)
    };
};

function formatDate(date) {
    let year = date.getFullYear();
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
}

function getPastDate(date, months) {
    let newDate = new Date(date);

    newDate.setMonth(newDate.getMonth() - months);

    return newDate;
}

exports.formatarDinheiro = (valor) => {
    const formatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
    return formatter.format(valor);
}

/** Alias para compatibilidade com código do sistema principal */
exports.formatarMoeda = exports.formatarDinheiro;

/** Converte valor monetário para número. Aceita número, formato BR (8.541,87) ou numérico (8541.87). */
exports.parseValorMonetario = (valor) => {
    if (valor == null || valor === '') return 0;
    if (typeof valor === 'number') return isNaN(valor) ? 0 : valor;
    const str = String(valor).trim().replace(/\s/g, '').replace(/R\$\s?/g, '');
    if (!str) return 0;
    if (str.includes(',')) {
        return parseFloat(str.replace(/\./g, '').replace(',', '.')) || 0;
    }
    return parseFloat(str) || 0;
};

exports.converterDataUsParaBr = (valor) => {
    if (!valor) return '';
    let dataStr = valor;
    if (typeof valor === 'string') {
        if (valor.includes('T')) dataStr = valor.split('T')[0];
        else if (valor.includes(' ')) dataStr = valor.split(' ')[0];
    }
    if (valor instanceof Date) {
        const year = valor.getFullYear();
        const month = String(valor.getMonth() + 1).padStart(2, '0');
        const day = String(valor.getDate()).padStart(2, '0');
        dataStr = `${year}-${month}-${day}`;
    }
    if (dataStr && dataStr.includes('-')) {
        const dataSplit = dataStr.split('-');
        if (dataSplit.length >= 3) {
            return `${dataSplit[2]}/${dataSplit[1]}/${dataSplit[0]}`;
        }
    }
    return '';
};

/** Alias para compatibilidade */
exports.formatarDataUS = exports.converterDataUsParaBr;


// WEBPACK FOOTER //
// ./src/util.js